import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Page } from "@/components/Page";

const CHAPTERS = [
  { n: "01", t: "Pai + filha, ideias + tecnologia", d: "A 3Duo nasceu de uma dupla especial: pai e filha. Juntamos imaginação e tecnologia para transformar ideias em peças únicas, com a nossa impressora 3D multicolor." },
  { n: "02", t: "Criatividade sem limites", d: "Desde um porta-chaves ao teu animal favorito — bonecos articulados, dragões flexíveis, decoração e gadgets. Se dá para imaginar, adoramos o desafio de imprimir." },
  { n: "03", t: "Qualidade em cada camada", d: "Criamos com cuidado cada detalhe: materiais resistentes, cores vivas e acabamentos cuidados para que cada peça seja bonita, durável e divertida." },
  { n: "04", t: "Feito com carinho, para ti", d: "Obrigado por fazeres parte desta aventura. Cada encomenda é preparada com atenção e enviada com muito carinho." },
];

export default function About() {
  return (
    <Page className="pt-32 md:pt-40 px-6 md:px-12 max-w-6xl mx-auto min-h-screen">
      <div className="max-w-3xl">
        <span className="inline-block rounded-full bg-accent text-accent-foreground text-sm font-semibold px-4 py-2">Sobre Nós</span>
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-4 leading-[1.05]">
          Damos vida a ideias em <span className="text-gradient">três dimensões</span>
        </h1>
      </div>

      <div className="mt-16 space-y-4">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5 }}
            data-testid={`chapter-${c.n}`}
            className="relative grid md:grid-cols-[auto,1fr] gap-6 md:gap-10 items-start border-t border-border pt-10"
          >
            <span className="font-display font-black text-6xl md:text-8xl text-muted leading-none select-none">{c.n}</span>
            <div className="md:pt-4">
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">{c.t}</h3>
              <p className="text-foreground/70 text-lg leading-relaxed mt-3 max-w-2xl">{c.d}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-16 rounded-[2.5rem] bg-foreground text-white p-10 md:p-14 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h3 className="font-display font-extrabold text-2xl md:text-3xl">Vamos criar algo juntos?</h3>
          <p className="text-white/60 mt-2">Peças personalizadas, presentes ou uma ideia maluca — estamos prontos.</p>
        </div>
        <Link to="/contactos" className="inline-flex items-center gap-2 rounded-full brand-gradient text-white font-bold px-8 py-4 transition-transform hover:scale-105 active:scale-95 whitespace-nowrap">
          Falar connosco <ArrowRight size={18} />
        </Link>
      </div>
    </Page>
  );
}
